export class ClassName {
  static readonly currentFirmWrapper = "current-firm-wrapper";

  static readonly transferDetailsWrapper = "transfer-details-wrapper";

  static readonly transferInstructions = "transfer-instructions-wrapper";

  static readonly personalInformation = "personal-information-wrapper";

  static readonly signWrapper = "sign-wrapper";
}
